import { InboxSearch } from "../inbox/scope";

/** Per-workspace sections, in sidebar order. Each one is a feature folder under `features/`. */
export const SECTIONS = [
  { key: "inbox", label: "Mail", to: "/w/$workspaceId/inbox" },
  { key: "tasks", label: "Tasks", to: "/w/$workspaceId/tasks" },
  { key: "chat", label: "Chat", to: "/w/$workspaceId/chat" },
  { key: "dashboard", label: "Dashboard", to: "/w/$workspaceId/dashboard" },
] as const;

export type Section = (typeof SECTIONS)[number];

/** The section in the current URL, so switching workspace keeps you on the same screen. */
export function sectionOf(pathname: string): Section {
  const key = /^\/w\/[^/]+\/([^/]+)/.exec(pathname)?.[1];
  const found = SECTIONS.find((s) => s.key === key);
  return found === undefined ? SECTIONS[0] : found;
}

/**
 * What a workspace switch keeps of the URL (WP-065): on Mail, the view (`kind`, or `app` for
 * GitHub), so People stays People and Receipts stays Receipts. A mailbox, a search, a tag, the
 * open conversation and an account or saved scope belong to the old workspace and are dropped;
 * other sections keep nothing.
 */
export function keptView(pathname: string, search: unknown): Pick<InboxSearch, "kind" | "app"> {
  if (!/^\/w\/[^/]+\/inbox(\/|$)/.test(pathname)) return {};
  const parsed = InboxSearch.safeParse(search);
  if (!parsed.success) return {};
  const { kind, app } = parsed.data;
  if (app !== undefined) return { app };
  return kind === undefined ? {} : { kind };
}
